import React from 'react';
import 'src/scss/new-scss/components/CaseComponent.scss';
import { Grid } from '@material-ui/core';
import Spinner from 'src/ui/library/Spinner/Spinner';
import { connect } from 'react-redux';
import { resetCaseDetail } from 'src/new-ui/features/NewDashboard/state/newDashboardAction.js';
import DashBoardViewContainer from './DashBoardViewContainer';
import LeftContentContainer from './LeftContentContainer';
import intl from 'react-intl-universal';

export class CaseComponentContainer extends React.Component {
  state = {
    caseId: null,
    caseDetail: null,
    caseNumber: null,
  };

  componentDidUpdate() {
    if (this.props.newDashboard && this.props.newDashboard.isLoaded === false && this.props.newDashboard.isCaseNumberLoaded === false) {
      this.setState({
        caseId: this.props.newDashboard.caseId,
        caseDetail: this.props.newDashboard.caseDetail,
        caseNumber: this.props.newDashboard.caseNumber,
      });
      this.props.resetCaseDetail();
    }
  }
  render() {
    return (
      <Grid container>
        <Grid item sm={4} lg={4} md={4}>
          <LeftContentContainer />
        </Grid>
        <Grid item sm={8} lg={8} md={8} className="table-height">
          {this.state.caseId && this.props.newDashboard && this.props.newDashboard.isLoaded === true ? (
            <DashBoardViewContainer
              caseId={this.state.caseId}
              caseNumber={this.state.caseNumber}
              history={this.props.history}
              caseDetail={this.state.caseDetail}
              isCorp={this.props.isCorp}
            />
          ) : this.props.newDashboard.caseId === null && this.props.newDashboard.caseDetail === null ? (
            <div className="no-item-text">{intl.get('newDashboard.common.noItemtoDisplay')}</div>
          ) : (
            <div style={{ margin: '10px 0px 10px 0px' }}>
              <Spinner size={30} />
            </div>
          )}
        </Grid>
      </Grid>
    );
  }
}

const mapStateToProps = state => {
  return {
    state: state,
    newDashboard: state.newDashboard,
  };
};

const mapDispatchToProps = {
  resetCaseDetail,
};

export default connect(mapStateToProps, mapDispatchToProps)(CaseComponentContainer);
